<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-transparent text-right">
              <button class="btn btn-success" @click.prevent="showModal">
                <i class="fa fa-plus"></i> Adicionar Revendedora
              </button>
              <button class="btn btn-primary" @click.prevent="ExportExcel">
                <i class="fas fa-file-excel"></i> Exportar Revendedoras
              </button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <label>Nome</label>
                  <b-form-input v-model="nome" />
                </div>
                <div class="col-4">
                  <label>CPF</label>
                  <b-form-input v-model="cpf" v-mask="'###.###.###-##'" />
                </div>
                <div class="col-4">
                  <label>Situação</label>
                  <b-form-select :options="optionStatus" v-model="status" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <b-table
                    :items="showRevendedoras"
                    :fields="headerRevendedoras"
                    :current-page="currentPage"
                    :per-page="perPage"
                    sticky-header
                    head-variant="ligth"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    stacked="md"
                    show-empty
                    empty-text="Nenhuma revendedora encontrada"
                    hover
                    bordered
                    borderless
                    striped
                    small
                    :busy="loading"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                      </div>
                    </template>
                    <template #cell(id)="row">
                      <b-button
                        variant="primary"
                        @click="editaRevendedora(row.value)"
                        ><i class="fa fa-edit" title="Editar"></i
                      ></b-button>
                      <b-button
                        variant="danger"
                        @click="deletarRevendedora(row.value)"
                        v-if="row.item.ativa === false"
                        title="Excluir"
                      >
                        <i class="fas fa-user-times"></i
                      ></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- **************** Início Modais ****************** -->
      <b-modal
        v-model="isshowModal"
        size="xl"
        id="modalRev"
        title="Cadastro de Revendedora"
      >
        <cadastro-revendedora
          :lista_revendedoras="revendedoras"
          :revendedora="revendedora"
          :classe_distribuidor="classe"
          :codigo-distribuidor="getDistributor"
          :meu_estado="estado"
          :ismodal="true"
          ref="revendedora"
          />
        <template #modal-footer>
          <b-button variant="primary" size="sm" @click="saveRevendedora">
            Salvar
          </b-button>
          <b-button variant="danger" size="sm" @click="isshowModal = false">
            Cancelar
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CadastroRevendedora from "./form.vue";
export default {
  name: "revendedoras",
  components: {
    CadastroRevendedora,
  },
  data() {
    return {
      revendedora: {
        id: null,
        nome: "",
        email: "",
        status: 1,
        desconto: 0,
        cpf: "",
        rg: "",
        data_nasc: "",
        cep: "",
        cidade: null,
        logradouro: "",
        bairro: "",
        complemento: "",
        contatos: [],
        pdv: 0,
        ativa: null,
      },
      status: null,
      nome: "",
      cpf: "",
      optionStatus: [
        {
          value: null,
          text: "Todos",
        },
        {
          value: true,
          text: "Ativa",
        },
        {
          value: false,
          text: "Inativa",
        },
      ],
      classe:
        parseInt(document.getElementById("classe_g").value) === 0 ? "A" : "G",
      create_pdv: document.getElementById("create_pdv").value,
      estado: document.getElementById("estado").value,
      revendedoras: [],
      headerRevendedoras: [
        {
          key: "nome",
          label: "Nome",
          sortable: true,
        },
        {
          key: "status",
          label: "Situação",
          sortable: true,
          formatter: (value, key, item) => {
            return item.ativa ? (item.ativa ? "Ativa" : "") : "Inativa";
          },
        },
        {
          key: "cidade",
          label: "Cidade",
          sortable: true,
          formatter: (value, key, item) => {
            return item.endereco ? item.endereco.cidade.nome : "";
          },
        },
        {
          key: "pdv",
          label: "PDV",
          formatter: (value, key, item) => {
            return item.pdv ? item.pdv.nome : "";
          },
        },
        {
          key: "cpf",
          label: "CPF",
          formatter: (value, key, item) => {
            return item.pessoa_fisica
              ? item.pessoa_fisica.cpf
                ? this.getMakCPF(item.pessoa_fisica.cpf)
                : ""
              : "";
          },
        },
        {
          key: "id",
          label: "#",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [35, 45, 55, 65],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      isshowModal: false,
      loading: false,
    };
  },
  methods: {
    list() {
      var vm = this;
      $(".loading").show();
      vm.loading = true;
      axios
        .get("/distribuidor/revendedora/listar")
        .then(function (response) {
          vm.revendedoras = response.data;
          vm.totalRows = response.data.length;
          $(".loading").hide();
          vm.loading = false;
        })
        .catch(function (error) {
          alert(error.response.data.join("\n")).console.log(error);
          $(".loading").hide();
          vm.loading = false;
        });
    },
    getMakCPF(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      return v;
    },
    async saveRevendedora() {
      const vm = this;
      await this.$refs.revendedora.saveRevendedora();
      if (this.$refs.revendedora.valida) {
        vm.closeModal();
        //location.reload();
        this.list();
      }
    },
    ExportExcel() {
      window.open("/distribuidor/revendedora/export", "_blank");
    },
    closeModal() {
      this.revendedora = {
        id: null,
        nome: "",
        email: "",
        status: 1,
        desconto: 0,
        cpf: "",
        rg: "",
        data_nasc: "",
        cep: "",
        cidade: null,
        logradouro: "",
        bairro: "",
        complemento: "",
        contatos: [],
        pdv: 0,
        indicada_por: null,
        loginApp: false,
        acessoCPF: null, 
        senha_app: null,
        confirmaSenha_app: null,
        app: {
          senha:'',
          confirma:'',
          user: null
        }
      };
      this.isshowModal = false;
    },
    showModal() {
      this.revendedora = {
        id: null,
        nome: "",
        email: "",
        status: 1,
        desconto: 0,
        cpf: "",
        rg: "",
        data_nasc: "",
        cep: "",
        cidade: null,
        logradouro: "",
        bairro: "",
        complemento: "",
        contatos: [],
        pdv: 0,
        indicada_por: null,
        loginApp: false,
        acessoCPF: null, 
        senha_app: null,
        confirmaSenha_app: null,
        app: {
          senha:'',
          confirma:'',
          user: null
        }
      };
      this.isshowModal = true;
    },

    editaRevendedora(id) {
      const vm = this;
      //console.log(id)
      $(".loading").show();
      axios
        .get("/distribuidor/revendedora/" + id)
        .then((response) => {
          let obj = response.data;
          let endereco = obj.endereco_id
            ? obj.endereco
              ? obj.endereco
              : null
            : null;
          //console.log(obj.pdv),
          vm.revendedora = {
            id: obj.id,
            nome: obj.nome,
            email: obj.email ? obj.email : "",
            status: obj.ativa ? 1 : 0,
            desconto: obj.desconto ? obj.desconto : 0,
            cpf: obj.pessoa_fisica_id
              ? obj.pessoa_fisica.cpf
                ? obj.pessoa_fisica.cpf
                : ""
              : "",
            rg: obj.pessoa_fisica_id
              ? obj.pessoa_fisica.rg
                ? obj.pessoa_fisica.rg
                : ""
              : "",
            data_nasc: obj.pessoa_fisica_id
              ? obj.pessoa_fisica.data_nasc
                ? moment(obj.pessoa_fisica.data_nasc)
                : ""
              : "",
            cep: endereco ? (endereco.cep ? endereco.cep : "") : "",
            cidade: endereco
              ? endereco.cidade
                ? endereco.cidade.ibge
                  ? endereco.cidade.ibge
                  : ""
                : ""
              : "",
            estado: endereco
              ? endereco.cidade
                ? endereco.cidade.estado.uf
                  ? endereco.cidade.estado.uf
                  : ""
                : ""
              : "",
            logradouro: endereco
              ? endereco.logradouro
                ? endereco.logradouro
                : ""
              : "",
            bairro: endereco ? (endereco.bairro ? endereco.bairro : "") : "",
            complemento: endereco
              ? endereco.complemento
                ? endereco.complemento
                : ""
              : "",
            contatos: [],
            
            pdv: obj.pdv_id ? obj.pdv_id : 0,
            login: obj.login ? obj.login : "",
            acessoCPF: obj.usuario ? obj.usuario : "",
            loginApp: obj.usuario ? true : false,
            usuario: obj.usuario ? obj.usuario : "",
            indicada_por: obj.indicada_por ? obj.indicada_por : null,
            empresa: obj.empresa,
            local_entrega: obj.local_entrega,
            app: {
              senha:'',
              user: obj.user ? obj.user : null
            }

          };
          vm.isshowModal = true;

          if (obj.contatos) {         
            var contatos = [];
            obj.contatos.forEach((item) => {
              let _obj = {};
              let fone = item.telefone.ddd + "" + item.telefone.numero;
              _obj.tipo = item.telefone.tipo;
              _obj.numero = fone;
              _obj.whatsapp = item.telefone.whatsapp ? 1 : 0;
              contatos.push(_obj);
            });
            vm.revendedora.contatos = contatos;
          }
          $(".loading").hide();
        })
        .catch(function (error) {
          console.log(error);
          $(".loading").hide();
        });
    },
    deletarRevendedora(id) {
      let b = confirm(
        "Deseja Realmente Deletar a Revendedora. \n Todos os dados serão definitivamente Perdidos."
      );

      if (!b) {
        return;
      }
      var vm = this;
      $(".loading").show();

      axios
        .post("/distribuidor/revendedora/" + id, {
          _method: "DELETE",
        })
        .then(function (response) {
          vm.list();
          $("#createModal").modal("hide");
        })
        .catch(function (error) {
          $(".loading").hide();

          console.log(error.response.data);

          alert(error.response.data.errors[0]);
        });
    },
  },
  computed: {
    showRevendedoras() {
      var data = this.revendedoras;
      const vm = this;
      if (this.nome) {
        data = data.filter((el) => {
          return el.nome.toUpperCase().indexOf(vm.nome.toUpperCase()) > -1;
        });
      }
      if (this.cpf) {
        let _cpf = vm.cpf.replace(/[^0-9]+/g, "");
        data = data.filter((el) => {
          if (el.pessoa_fisica_id) {
            if (el.pessoa_fisica.cpf) {
              return el.pessoa_fisica.cpf.indexOf(_cpf.toString()) !== -1;
            }
          }
        });
      }
      if (this.status) {
        data = data.filter((el) => {
          return el.ativa === true;
        });
      } else {
        if (this.status == null) {
          return data;
        } else {
          data = data.filter((el) => {
            return el.ativa === false;
          });
        }
      }
      return data;
    },
    getDistributor() {
      return this.$store.getters['user/getDistributor']() != null 
        ? this.$store.getters['user/getDistributor']()?.codigo
        : null;
    }
  },

  mounted() {
    this.list();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/revendedora/Main.vue